import {createTableState} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
})

const getters = {}

const actions = {
    async get({commit}, {product_id} = {}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_product_upgrade_path'], {
                urlVars: {productId: product_id}
            })

            const {data} = res.data
            commit('updateTableData', data)
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async add({commit}, {formData, product_id}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.post(this._vm.endpoints['ecommerce_product_upgrade_path'], formData, {
                urlVars: {productId: product_id}
            })

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },

    async delete({commit}, {id, product_id}) {
        commit('setLoading', true)

        try {
            const res = await this._vm.axios.delete(this._vm.endpoints['ecommerce_product_upgrade_path'] + '/' + id, {
                urlVars: {productId: product_id}
            })

            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response.data);
        } finally {
            commit('setLoading', false)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
